import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { LiveTrackingState } from '@app/core/states/live-tracking.state';
import { UploadFileList } from '@app/core/states/upload.actions';
import { RootBac } from '@app/library/models/bac.model';
import { Actions, ofActionDispatched, Select, Store } from '@ngxs/store';
import { CheckListAddTrack } from '@radioking/onboarding-checklist';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-library-upload-track',
  templateUrl: './library-upload-track.component.html',
  styleUrls: ['./library-upload-track.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LibraryUploadTrackComponent implements OnInit {
  accept = '.mp3';

  @ViewChild('trackUploadFileInput', { static: true })
  trackUploadFileInput: ElementRef;

  @Input()
  box: RootBac;

  @Input()
  isMainButton = true;

  @Select(LiveTrackingState.canUpload)
  canUpload$: Observable<boolean>;

  pulse = false;

  constructor(
    private readonly store: Store,
    private readonly actions$: Actions,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    if (this.isMainButton) {
      this.actions$.pipe(ofActionDispatched(CheckListAddTrack)).subscribe(() => {
        this.pulse = true;
        this.cdr.detectChanges();
      });
    }
  }

  selectTrack() {
    this.pulse = false;
    this.cdr.detectChanges();
    if (this.trackUploadFileInput) {
      this.trackUploadFileInput.nativeElement.click();
    }
  }

  async onFileSelect(event: any) {
    this.store.dispatch(new UploadFileList(event.target.files, this.box));
    this.trackUploadFileInput.nativeElement.value = '';
  }
}
